import menuBg from 'ASSETS/img/menu/menu_bg_bw.jpg';

export const jd = {
  btnColor: {
    c0002: '#b51804',
    c0003: '#ca5d5b',
    c0023: '#edf0f0',
    c0024: '#cf8388',
    c0025: '#ba5452',
    // 原color下没有，新添加c004开头
    c0041: '#b71901',
    c0042: '#c3c3c3',
  },
  chartColor: {
    c0001: '#3a3a3a', //x轴字体颜色
    c0002: '#9f9f9f', //y轴字体颜色
    c0003: '#3C424820', //区域横线的颜色 , //
    c0004: '#8d1104', //['#8d1104', '#b51804', '#ca5d5b', '#eb9f9c', '#ffc5bf'], //饼图的颜色列表
    c0005: '#b51804', //['#b51804', '#ca5d5b', '#eb9f9c', '#f8d8d4'], //柱状图的颜色列表
    c0006: '#ca5d5b',
    c0007: '#eb9f9c',
    c0008: '#f8d8d4',
    c0009: '#f9010c', //['#f9010c', '#009dbf', '#f16420'], //折线图的颜色列表
    c0010: '#009dbf',
    c0011: '#f16420',
    c0012: '#ba5452',
    c0013: '#871A1D',
    c0014: '#9E1E22',
    c0015: '#B32227',
    c0016: '#C8262B',
    c0017: '#D72F35',
    c0018: '#DB4449',
    c0019: '#DF595D',
    c0020: '#8F2E2C',
    c0021: '#931C20',
    c0022: 'rgba(56,124,185,0.99)',
    c0023: '#1C928E',
    c0024: '#1C2092',
    c0025: '#531C92',
    c0026: '#DB4449',
    c0027: '#DF595D',
    c0028: '#928E1C',
    // c0021: 'rgba(230,107,26,1)',
    // c0022: 'rgba(159,92,187, 0.99)',
    // c0023: 'rgba(50,107,208, 0.99)',
    // c0024: 'rgba(168, 32, 37, 1)',
    // c0025: 'rgba(243, 119, 116, 1)',
    // c0026: 'rgba(238, 86, 82, 1)',
    // c0027: 'rgba(245,169,43,1)',
    // c0028: 'rgba(56,124,185,0.99)',
  },
  chartBoxColor: {
    c0029: 'rgba(242, 242, 242, 1)',
    c0001: '#A82025',
    c0002: '#818181',
  },
  inpColor: {
    c0002: '#b51804',
    c0014: '#3a3a3a',
    c0015: '#737373',
    c0023: '#edf0f0',
    c0024: '#cf8388',
    c0026: '#edf0f0',
    transparent: 'transparent',
  },
  selecColor: {
    c0002: '#b51804',
    c0014: '#3a3a3a',
    c0015: '#737373',
    c0023: '#edf0f0',
    c0024: '#cf8388',
    c0026: '#edf0f0',
    c0006: '#fceeec',
    c0007: '#d9d9d9',
    c0008: '#d9d9d9',
    transparent: 'transparent',
  },
  tblColor: {
    c0023: '#edf0f0',
    c0025: '#ba5452',
    c0007: '#b71901',
    c0005: '#ffc5bf',
    c0027: '#f8d8d4',
    c0028: 'rgba(183,25,1,0.2)',
    ac0027: '#FCEDEA',
    // 自定义 base color下原来没有 以c004起头
    c0040: 'rgb(241, 236, 235)',
  },
  chkColor: {
    c0007: '#b71901',
  },
  tabColor: {
    c0023: '#edf0f0',
    c0014: '#3a3a3a',
    c0002: '#b51804',
  },
  layoutColor: {
    c0017: '#750504',
    c0018: '#b43c43',
    c0019: 'rgb(255,255,255,0.36)',
    c0020: 'rgb(255,255,255,0.65)',
    c0021: 'rgb(55,7,1,0.4)',
    c0022: '#d9d9d9',
    c0030: 'rgba(186, 83, 80, 1)',
    c0007: '#b71901',
  },
  timeLineColor: {
    c0005: '#ffc5bf',
    c0017: '#750504',
    c0003: '#ca5d5b',
  },
  switchColor: {
    c0025: '#ba5452',
  },
  modalColor: {
    c0002: '#b51804',
  },
  datePickerColor: {
    c0001: '#3a3a3a',
    c0002: '#737373',
    c0003: '#edf0f0',
    c0004: '#cf8388',
    c0005: '#d9d9d9',
    c0006: '#fceeec',
    c0007: '#d9d9d9',
    transparent: 'transparent',
  },
  //级联菜单样式
  cascaderColor: {
    c0001: '#3a3a3a',
    c0002: '#737373',
    c0003: '#edf0f0',
    c0004: '#cf8388',
    c0005: '#d9d9d9',
    c0006: '#fceeec',
    c0007: '#d9d9d9',
    transparent: 'transparent',
  },
  // 渐变色
  gradColor: {
    g0001: ['#fc000b', '#9f0001'],
  },
  // 需要随主题色改变而改变，且无法归入共通的部分样式
  others: {
    // 渐变色
    gradColor: {
      g0001: ['#fc000b', '#9f0001'],
    },
    // 背景图片
    imgs: {
      bg0001: menuBg,
    },
    fontColor: {
      c0001: '#3a3a3a', //head的标题颜色
      c0012: '#9f9f9f',
      c0004: '#eb9f9c', //百分比大于0的颜色
      c0011: '#009dbf', //百分比小于于0的颜色
      g0001: ['#fc000b', '#9f0001'], // 概览页会员文字渐变色
      g0002: ['#333333', '#666666'], // 概览页会员文字渐变色
    },
  },
};
